import { AccordionBodyItemView } from 'component/Accordion';
import React from 'react';

export const NumberOfPeopleSurveyedView = (props) => {
  const { formData } = props;

  return (
    <AccordionBodyItemView
      accordionSubId={(
        <div>3.3</div>
      )}
      titleUA="Кількість опитаних осіб"
      titleEN="Number of people surveyed"
      children={formData?.info?.final_indicators?.number_of_people_surveyed || 0}
    />
   );
};